import { DurationPeriodType } from '@senet-uiverse/ui';

export interface IPasses {
  expiration_period_type: DurationPeriodType;
  duration_period_type: DurationPeriodType;
  expiration_period_length: number | null;
  available_periods: IPeriods[];
  duration_period_length: number;
  is_already_purchased: boolean;
  billing_type: EBillingType;
  active_period: IPeriods;
  price_for_user: string;
  spent_minutes?: number;
  total_minutes?: number;
  is_active: boolean;
  zones: IPassZone[];
  offices: number[];
  weight?: number;
  price: string;
  name: string;
  id: number;
}

export interface IPassZone {
  office: number;
  color: string;
  name: string;
  id: number;
}

export interface IPeriods extends Record<string, number> {
  start_minute: number;
  end_minute: number;
  start_hour: number;
  start_day: number;
  end_hour: number;
  end_day: number;
}

export enum EBillingType {
  BONUS_OR_MAIN = 'Bonus Or Main',
  BONUS_ONLY = 'Bonus Only',
  MAIN_ONLY = 'Main Only',
}

export interface IPassDetail extends IPasses {
  account_bonus_amount: string;
  account_amount: string;
}

export interface IBuyTicketPayload {
  ticket_id: number;
  quantity: number;
  amount_in_bonuses?: string;
  office_id: number;
  office_zone_id: number;
  promo_code?: string;
}

export interface IPromocodeValidation {
  amount: number;
  promo_type: string;
}

export interface IMyPassResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: IMyPass[];
}

export interface IMyPass {
  id: number;
  weight: number;
  name: string;
  total_minutes: number | null;
  spent_minutes: number | null;
  expiration_time: string | null;
  is_activated: boolean;
  active_period: IPeriods;
  available_periods: IPeriods[];
  available_zones: IPassZone[];
  is_active_billable: boolean;
  expiration_period_length: number | null;
  expiration_period_type: DurationPeriodType;
  is_available_for_activation: boolean;
  quantity: number | null;
  offices: number[];
  zones: IPassZone[];
  duration_period_length: number;
  duration_period_type: DurationPeriodType;
  is_active: boolean;
  billing_type: EBillingType;
  price_for_user: string;
  price: string;
  is_already_purchased: boolean;
}

export type TPassData = IPasses | IMyPass;
